import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { LogInURL } from "../../Variables/variable";

const leftBarRoute = {addRecord:"add_record", testRecord:"test_record", addPatient:"new_patient", questions:"questions"};
const leftBarText = {addRecord:"輸入就診記錄", testRecord:"查詢就診紀錄", addPatient:"新增基本資料", questions: "遇到問題"};
const path_to_route = {};
Object.entries(leftBarRoute).map(([key, value]) => path_to_route[value] = key);

function LeftBar({leftBarList}){
    let tmp_list = leftBarList.map(item => {return [item, "w-1/5 pt-1 text-[#FFFFFF] text-2xl font-bold"]});
    const [classList, setClass] = useState(Object.fromEntries(tmp_list));

    const location = useLocation();
    
    const logOut = () => {
        sessionStorage.setItem('isLoggedIn', false);
        sessionStorage.setItem('access_token', null);
        sessionStorage.setItem('refresh_token', null);
        window.location.href = LogInURL;
    }
    
    useEffect(() => {
        const paths = location.pathname.split('/');
        const pathname = path_to_route[paths[paths.length-1]];
        selectLeftBar(pathname, classList, setClass);
    }, [location])

    return(
        <>
        <div className="w-screen border-b-2" >
            <ul>
                <Link to=""><li className="text-4xl bg-gradient-to-b from-[#9cc5ef] to-[#a4f3d3] pt-1 pb-1 ml-2 mr-2">信賴眼科診所</li></Link>
                <table className="w-full text-center bg-[#1D5A50] table-fixed">
                    <tr>
                    {leftBarList.map((item) => (
                        <td className={classList[item]}>
                            <Link to={leftBarRoute[item]}> <li key={item} className="">{leftBarText[item]}</li></Link>
                        </td>
                    ))}
                    <td className="pt-1 text-[#FFFFFF] font-bold text-2xl m-auto hover:cursor-pointer" onClick={() => logOut()}>登出</td>
                    </tr>
                </table>
            </ul>
        </div>
        </>
    )
}

function selectLeftBar(item, classList, setClass) {
    setClass(Object.fromEntries(
        Object.entries(classList).map(
            ([key, value]) => {
                return [key, key === item ? "table-fixed m-auto pl-5 pr-5 pt-1 pb-1 border border-[#000] border-b-4 border-b-[#7EE5AE] text-[#FFFFFF] text-2xl font-bold" : "table-fixed m-auto pl-5 pr-5 pt-1 text-[#FFFFFF] text-2xl font-bold"]
            })
    ));
}

export default LeftBar;